export enum PromoterDetailViewType{    
    Detail,
    Last20Transactions,
    SearchTransactions,
    CreditAdjustment
}
export enum TransactionType{
    TopUp,
    MessagingAll,
    MessagingText,
    MessagingImage,
    MessagingUrl,
    MessagingAudio,
    MessagingVideo,
    PromotionTopUp,
    Adjustment
}
export enum PromoterState{
    Approved,
    AwaitingApproval,
    Rejected,
    Suspended
}